import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Field } from 'kts-scaffold-framework/utils/doc';
import { Row, Col, Form, Badge, Tag, Table } from 'antd';
import {SettlementState} from './Modules.Constant';
const css = require('./index.scss');
const { formatTime, formatDate } = Field;
/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class Info extends UIBasic<IProps, ModulesState> {
    
    public  getBillState = (data: SettlementState): JSX.Element => {
        if (data === SettlementState.已创建) {
            return <Tag color="green">已创建</Tag>;
        } else if (data === SettlementState.已发送) {
            return <Tag color="green">已发送</Tag>;
        } else if (data === SettlementState.已接受) {
            return <Tag color="green">已接受</Tag>;
        } else if (data === SettlementState.已拒绝) {
            return <Tag color="red">已拒绝</Tag>;
        } else if (data === SettlementState.已作废) {
            return <Tag color="red">已作废</Tag>;
        }
        // return <Tag color="red">'无可识别类型'</Tag>;
    }
    public getMatchState = (data: SettlementState): JSX.Element => {
        if (data === SettlementState.匹配中) {
            return <Tag color="green">匹配中</Tag>;
        }
        if (data === SettlementState.未匹配) {
            return <Tag color="orange">未匹配</Tag>;
        }
        if (data === SettlementState.已匹配) {
            return <Tag color="green">已匹配</Tag>;
        }
        // return <Tag color="red">'无可识别类型'</Tag>;
    }

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    render() {
        const FormItem = Form.Item;
        const formItemLayout = {
            labelCol: {
                span: 6
            },
            wrapperCol: {
                span: 18
            }
        };
        return (
            <div className={css['input-settlement-info']}>
                    <Row>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="单号">
                                <span className="ant-form-text">
                                    {this.modulesState.detailInfo && this.modulesState.detailInfo.bizNoticeId}
                                </span>
                            </FormItem>
                            <FormItem {...formItemLayout} label="销方名称">
                                <span className="ant-form-text">
                                    {this.modulesState.detailInfo &&
                                        this.modulesState.detailInfo.supplierName}
                                </span>
                            </FormItem>
                            <FormItem {...formItemLayout} label="购方名称">
                                <span className="ant-form-text">
                                    {this.modulesState.detailInfo && this.modulesState.detailInfo.buyerName}
                                </span>
                            </FormItem>
                            <FormItem {...formItemLayout} label="结算周期">
                                <span className="ant-form-text">
                                    {this.modulesState.detailInfo &&
                                        formatDate(
                                            this.modulesState.detailInfo.settlBeginTime
                                        )}
                                    {this.modulesState.detailInfo && this.modulesState.detailInfo.settlBeginTime && '至'}
                                    {this.modulesState.detailInfo &&
                                        formatDate(
                                            this.modulesState.detailInfo.settlEndTime
                                        )}
                                </span>
                            </FormItem>
                            <FormItem {...formItemLayout} label="结算部门">
                                <span className="ant-form-text">
                                    {this.modulesState.detailInfo &&
                                        this.modulesState.detailInfo.buyerDepartment} 
                                </span>
                            </FormItem>
    {/*                         
                            <FormItem {...formItemLayout} label="备注">
                                <span className="ant-form-text">
                                    {this.modulesState.detailInfo && this.modulesState.detailInfo.remark}
                                </span>
                            </FormItem> */}
                            
                            <FormItem {...formItemLayout} label="备注">
                                <div className="input-remark">
                                    <span className="ant-form-text">
                                        {this.modulesState.detailInfo && this.modulesState.detailInfo.remark}
                                    </span>
                                </div>
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="时间">
                                <span className="ant-form-text">
                                    {this.modulesState.detailInfo &&
                                        formatDate(this.modulesState.detailInfo.createTime)}
                                </span>
                            </FormItem>
                            <FormItem {...formItemLayout} label="总税额">
                                <span className="ant-form-text">
                                    {Field.formatMoney(this.modulesState.detailInfo && this.modulesState.detailInfo.amountTax, 2)}
                                </span>
                            </FormItem>
                                <FormItem {...formItemLayout} label="总金额">
                                    <span className="ant-form-text">
                                        {Field.formatMoney(this.modulesState.detailInfo &&this.modulesState.detailInfo.amountWithoutTax, 2)}
                                    </span>
                                </FormItem>
                            <FormItem {...formItemLayout} label="价税合计">
                                <span className="ant-form-text">
                                    {Field.formatMoney(this.modulesState.detailInfo && this.modulesState.detailInfo.amountSum, 2)}
                                </span>
                            </FormItem>
                            <FormItem {...formItemLayout} label="状态">
                                <span className="ant-form-text ant-td-status info-status">
                                    {this.modulesState.detailInfo &&
                                        this.getMatchState(
                                            this.modulesState.detailInfo.billMatchState
                                        )}
                                    {this.modulesState.detailInfo &&
                                        this.getBillState(
                                            this.modulesState.detailInfo.noticeBillState
                                        )}
                                </span>
                            </FormItem>
                            {this.modulesState.detailInfo &&
                                this.modulesState.detailInfo.noticeBillState === 'REFUSED' && (
                                    <FormItem {...formItemLayout} label="拒绝原因">
                                        <span className="ant-form-text ant-td-status info-status">
                                            {this.modulesState.detailInfo.refusedReason}
                                        </span>
                                    </FormItem>
                                )}
                            
                        </Col>
                    </Row>
                </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/InputSettlement/UI.Info.tsx